import ReviewShowMoreSection from '../enums/ReviewShowMoreSection';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logReviewFiltersShowMoreClickedParams = {
  show_more_section: ReviewShowMoreSection;
  trail_id: number;
};

/**
 * Trigger when users click the Show more CTA on the filter sheet in reviews
 * @param params - Attributes to log with the amplitude event
 * @param params.show_more_section - The section in review filters where show more was clicked
 * @param params.trail_id
 */
const logReviewFiltersShowMoreClicked = ({ show_more_section, trail_id }: logReviewFiltersShowMoreClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('review filters show more clicked', { 'show more section': show_more_section, 'trail id': trail_id }, callback);
};

export default logReviewFiltersShowMoreClicked;
